import { render, staticRenderFns } from "./TargetSourceAttribute.vue?vue&type=template&id=3011e7b3&scoped=true&"
import script from "./TargetSourceAttribute.vue?vue&type=script&lang=ts&"
export * from "./TargetSourceAttribute.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3011e7b3",
  null
  
)

export default component.exports